import AgencyOnboardingClickInjector from '@root/joinroot.com/src/components/agents/agency-onboarding-modal/agency-onboarding-click-injector';
import AgencyOnboardingModal from '@root/joinroot.com/src/components/agents/agency-onboarding-modal/agency-onboarding-modal';
import React, { useState } from '@root/vendor/react';

export default function AgencyOnboardingModalDynamicRenderer() {
  const [isShowing, setIsShowing] = useState(false);

  return (
    <>
      <AgencyOnboardingClickInjector
        buttonText={'Get appointed'}
        onClick={() => setIsShowing(true)}
      />
      <AgencyOnboardingModal
        isShowing={isShowing}
        onClose={() => setIsShowing(false)}
      />
    </>
  );
}
